<script setup lang="ts">
interface HelpSection {
  items: readonly string[]
  title: string
}

defineProps<{
  sections: readonly HelpSection[]
  title: string
}>()

const { close, isOpen } = useGameHelpModal()
const { t } = useI18n()
</script>

<template>
  <UModal
    v-model:open="isOpen"
    :ui="{
      overlay: 'sfg-about-overlay',
      content: 'rotate-[0.6deg]',
    }"
  >
    <template #content>
      <div class="bg-brand-ink text-brand-chalk rounded-card overflow-hidden">
        <div class="flex flex-col items-center gap-6 p-8 sm:p-10">
          <UIcon
            name="mdi:help-circle-outline"
            class="size-14 text-brand-yellow shrink-0"
          />

          <h2 class="font-editorial italic font-black text-[28px] sm:text-[32px] leading-none text-center">
            {{ title }}
          </h2>

          <div class="flex flex-col gap-6 max-w-lg w-full">
            <section
              v-for="(section, i) in sections"
              :key="i"
              class="flex flex-col gap-2"
            >
              <h3 class="font-display uppercase text-[12px] tracking-[0.16em] text-brand-yellow">
                {{ section.title }}
              </h3>
              <ul class="flex flex-col gap-1.5 font-body text-body-sm leading-relaxed">
                <li
                  v-for="(item, j) in section.items"
                  :key="j"
                  class="flex gap-3"
                >
                  <span aria-hidden="true" class="text-brand-yellow shrink-0 leading-relaxed">•</span>
                  <span>{{ item }}</span>
                </li>
              </ul>
            </section>
          </div>

          <SfgButton
            variant="primary"
            size="sm"
            @click="close"
          >
            {{ t('gameHelp.closeButton') }}
          </SfgButton>
        </div>
      </div>
    </template>
  </UModal>
</template>
